/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Discount_InvalidInputs */

const vi_einvoice_draft_discount_invalid = /** @type {(inputs: Einvoice_Draft_Discount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu phải là số từ 0 đến 100%.`)
};

/**

* @param {Einvoice_Draft_Discount_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_discount_invalid = /** @type {((inputs?: Einvoice_Draft_Discount_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Discount_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_discount_invalid(inputs)
});